// Standort-Unterseiten für lokale SEO. Jeder Ort mit einzigartigem Text.

export const locations = [
  {
    slug: "gersthofen",
    name: "Gersthofen",
    metaTitle:
      "Gebäudereinigung Gersthofen | Büro- & Unterhaltsreinigung | MAG Facility Services",
    metaDescription:
      "Professionelle Gebäudereinigung in Gersthofen: Unterhaltsreinigung, Büro-, Glas- & Treppenhausreinigung. Zuverlässig, versichert & termintreu. Jetzt kostenloses Angebot anfordern!",
    intro: [
      "Als Gebäudereinigung aus dem Großraum Augsburg sind wir regelmäßig in Gersthofen im Einsatz. Die wachsende Stadt nördlich von Augsburg mit ihren zahlreichen Gewerbebetrieben, Büros und Wohnanlagen vertraut auf zuverlässige Reinigungspartner – und genau hier sind wir für Sie da. Ob Unterhaltsreinigung für Ihr Büro, hygienische Praxisreinigung oder die regelmäßige Treppenhausreinigung in Wohnanlagen: Wir sorgen in Gersthofen für dauerhaft saubere und repräsentative Objekte.",
      "Dank kurzer Wege zwischen Augsburg und Gersthofen sind wir schnell vor Ort und arbeiten termintreu, versichert und mit festem Ansprechpartner. Auf Wunsch reinigen wir außerhalb Ihrer Geschäftszeiten, damit Ihr Betrieb ungestört weiterläuft.",
    ],
  },
  {
    slug: "neusaess",
    name: "Neusäß",
    metaTitle:
      "Gebäudereinigung Neusäß | Büro- & Gewerbereinigung | MAG Facility Services",
    metaDescription:
      "Gebäudereinigung in Neusäß: Unterhalts-, Büro-, Glas- & Grundreinigung für Gewerbe, Praxen & Wohnanlagen. Zuverlässig & versichert. Jetzt kostenloses Angebot anfordern!",
    intro: [
      "In Neusäß westlich von Augsburg übernehmen wir die professionelle Reinigung von Büros, Praxen, Gewerbeobjekten und Wohnanlagen. Als erfahrene Gebäudereinigung kennen wir die Anforderungen der Region und stimmen unsere Leistungen individuell auf Ihr Objekt ab – von der täglichen Unterhaltsreinigung bis zur intensiven Grundreinigung.",
      "Unser geschultes Team arbeitet zuverlässig, diskret und nach klaren Qualitätsstandards. Neusäßer Unternehmen und Hausverwaltungen profitieren von fairen Preisen, kurzen Reaktionszeiten und einer festen Ansprechperson, die Ihr Objekt genau kennt.",
    ],
  },
  {
    slug: "friedberg",
    name: "Friedberg",
    metaTitle:
      "Gebäudereinigung Friedberg | Unterhalts- & Glasreinigung | MAG Facility Services",
    metaDescription:
      "Professionelle Gebäudereinigung in Friedberg bei Augsburg: Büro-, Unterhalts-, Glas- & Treppenhausreinigung. Zuverlässig, versichert & termintreu. Jetzt Angebot anfordern!",
    intro: [
      "Friedberg östlich von Augsburg ist mit seiner historischen Altstadt und den umliegenden Gewerbegebieten eine Stadt mit vielfältigen Reinigungsanforderungen. Wir betreuen hier Büros, Ladenlokale, Praxen und Wohnanlagen mit professioneller Gebäudereinigung – von der regelmäßigen Unterhaltsreinigung über streifenfreie Glasreinigung bis zur Treppenhausreinigung.",
      "Als regionaler Partner sind wir schnell in Friedberg vor Ort, arbeiten termintreu und versichert und passen Intervalle sowie Uhrzeiten flexibel an Ihren Betrieb an. So bleibt Ihr Objekt dauerhaft gepflegt und einladend.",
    ],
  },
  {
    slug: "koenigsbrunn",
    name: "Königsbrunn",
    metaTitle:
      "Gebäudereinigung Königsbrunn | Büro- & Unterhaltsreinigung | MAG Facility Services",
    metaDescription:
      "Gebäudereinigung in Königsbrunn: Unterhalts-, Büro-, Glas- & Grundreinigung für Gewerbe, Praxen & Wohnanlagen. Zuverlässig & versichert. Jetzt kostenloses Angebot anfordern!",
    intro: [
      "In Königsbrunn südlich von Augsburg sind wir für Unternehmen, Praxen, Hausverwaltungen und Privatkunden im Einsatz. Von der täglichen Büroreinigung über die Grundreinigung bis zur Glas- und Fassadenreinigung bieten wir alle Leistungen der Gebäudereinigung aus einer Hand – zuverlässig und auf Ihren Bedarf zugeschnitten.",
      "Königsbrunner Kunden schätzen unsere kurzen Wege, die termintreue Arbeitsweise und die transparente Preisgestaltung. Auf Wunsch reinigen wir früh morgens, abends oder am Wochenende, damit Ihr Ablauf nicht gestört wird.",
    ],
  },
  {
    slug: "stadtbergen",
    name: "Stadtbergen",
    metaTitle:
      "Gebäudereinigung Stadtbergen | Büro- & Gewerbereinigung | MAG Facility Services",
    metaDescription:
      "Professionelle Gebäudereinigung in Stadtbergen: Unterhalts-, Büro-, Glas- & Treppenhausreinigung für Gewerbe & Wohnanlagen. Versichert & zuverlässig. Jetzt Angebot anfordern!",
    intro: [
      "Stadtbergen grenzt direkt an Augsburg – für uns bedeutet das besonders kurze Wege und schnelle Verfügbarkeit. Wir übernehmen hier die Reinigung von Büros, Gewerbeobjekten, Praxen und Wohnanlagen, ob regelmäßige Unterhaltsreinigung, Treppenhausreinigung oder streifenfreie Glasreinigung.",
      "Mit geschultem Personal, klaren Standards und einer festen Ansprechperson sorgen wir in Stadtbergen für konstante Sauberkeit und einen professionellen Eindruck – termintreu, versichert und zu fairen Konditionen.",
    ],
  },
  {
    slug: "bobingen",
    name: "Bobingen",
    metaTitle:
      "Gebäudereinigung Bobingen | Unterhalts- & Industriereinigung | MAG Facility Services",
    metaDescription:
      "Gebäudereinigung in Bobingen: Unterhalts-, Büro-, Glas- & Industriereinigung für Gewerbe, Hallen & Wohnanlagen. Zuverlässig & versichert. Jetzt kostenloses Angebot anfordern!",
    intro: [
      "Bobingen südlich von Augsburg ist bekannt für seine Industrie- und Gewerbebetriebe. Neben der klassischen Büro- und Unterhaltsreinigung übernehmen wir hier auch die Reinigung von Produktions- und Lagerhallen sowie Industrieböden – auf Wunsch außerhalb Ihrer Betriebszeiten und nach Ihren Sicherheitsvorgaben.",
      "Ob Gewerbe, Wohnanlage oder Praxis: Wir arbeiten zuverlässig, versichert und termintreu und stimmen Umfang und Intervalle genau auf Ihr Objekt in Bobingen ab.",
    ],
  },
  {
    slug: "schwabmuenchen",
    name: "Schwabmünchen",
    metaTitle:
      "Gebäudereinigung Schwabmünchen | Büro- & Unterhaltsreinigung | MAG Facility Services",
    metaDescription:
      "Professionelle Gebäudereinigung in Schwabmünchen: Unterhalts-, Büro-, Glas- & Grundreinigung für Gewerbe, Praxen & Wohnanlagen. Zuverlässig & versichert. Jetzt Angebot anfordern!",
    intro: [
      "In Schwabmünchen südlich von Augsburg übernehmen wir die professionelle Reinigung von Büros, Praxen, Gewerbeobjekten und Wohnanlagen. Als erfahrene Gebäudereinigung sind wir regelmäßig in der Region unterwegs und stimmen unsere Leistungen individuell auf Ihr Objekt ab – von der täglichen Unterhaltsreinigung bis zur intensiven Grundreinigung.",
      "Schwabmünchner Unternehmen und Hausverwaltungen profitieren von verlässlichen Intervallen, fairen Preisen und einer festen Ansprechperson. Auf Wunsch reinigen wir außerhalb Ihrer Geschäftszeiten, damit Ihr Betrieb ungestört bleibt.",
    ],
  },
  {
    slug: "aichach",
    name: "Aichach",
    metaTitle:
      "Gebäudereinigung Aichach | Büro- & Gewerbereinigung | MAG Facility Services",
    metaDescription:
      "Gebäudereinigung in Aichach: Unterhalts-, Büro-, Glas- & Treppenhausreinigung für Gewerbe, Praxen & Wohnanlagen. Zuverlässig, versichert & termintreu. Jetzt Angebot anfordern!",
    intro: [
      "Aichach nordöstlich von Augsburg ist eine charmante Kreisstadt mit vielfältigen Reinigungsanforderungen. Wir betreuen hier Büros, Ladenlokale, Praxen und Wohnanlagen mit professioneller Gebäudereinigung – von der regelmäßigen Unterhaltsreinigung über die Glasreinigung bis zur Treppenhausreinigung.",
      "Als regionaler Partner arbeiten wir termintreu, versichert und mit klaren Qualitätsstandards. Intervalle und Uhrzeiten passen wir flexibel an Ihren Betrieb in Aichach an.",
    ],
  },
  {
    slug: "mering",
    name: "Mering",
    metaTitle:
      "Gebäudereinigung Mering | Unterhalts- & Büroreinigung | MAG Facility Services",
    metaDescription:
      "Professionelle Gebäudereinigung in Mering: Unterhalts-, Büro-, Glas- & Grundreinigung für Gewerbe, Praxen & Wohnanlagen. Versichert & zuverlässig. Jetzt Angebot anfordern!",
    intro: [
      "In Mering südöstlich von Augsburg sind wir für Unternehmen, Praxen, Hausverwaltungen und Privatkunden im Einsatz. Von der Büroreinigung über die Grundreinigung bis zur Glasreinigung bieten wir alle Leistungen der Gebäudereinigung aus einer Hand – zuverlässig und auf Ihren Bedarf zugeschnitten.",
      "Kunden in Mering schätzen unsere kurzen Reaktionszeiten, die termintreue Arbeitsweise und die transparente Preisgestaltung – auf Wunsch auch außerhalb der Geschäftszeiten.",
    ],
  },
  {
    slug: "kissing",
    name: "Kissing",
    metaTitle:
      "Gebäudereinigung Kissing | Büro- & Gewerbereinigung | MAG Facility Services",
    metaDescription:
      "Gebäudereinigung in Kissing: Unterhalts-, Büro-, Glas- & Treppenhausreinigung für Gewerbe, Praxen & Wohnanlagen. Zuverlässig & versichert. Jetzt kostenloses Angebot anfordern!",
    intro: [
      "Kissing südöstlich von Augsburg ist eine wachsende Gemeinde mit Gewerbe, Praxen und zahlreichen Wohnanlagen. Wir übernehmen hier die professionelle Reinigung – ob regelmäßige Unterhaltsreinigung, Treppenhausreinigung oder streifenfreie Glasreinigung.",
      "Mit geschultem Personal, festen Ansprechpartnern und verlässlichen Intervallen sorgen wir in Kissing für konstante Sauberkeit – termintreu, versichert und zu fairen Konditionen.",
    ],
  },
  {
    slug: "landsberg-am-lech",
    name: "Landsberg am Lech",
    metaTitle:
      "Gebäudereinigung Landsberg am Lech | Büro- & Unterhaltsreinigung | MAG Facility Services",
    metaDescription:
      "Professionelle Gebäudereinigung in Landsberg am Lech: Unterhalts-, Büro-, Glas- & Grundreinigung für Gewerbe, Praxen & Wohnanlagen. Versichert & zuverlässig. Jetzt Angebot anfordern!",
    intro: [
      "Landsberg am Lech mit seiner historischen Altstadt und den umliegenden Gewerbegebieten betreuen wir mit dem kompletten Spektrum der Gebäudereinigung. Ob Büro, Praxis, Ladenlokal oder Wohnanlage – von der Unterhaltsreinigung über die Glasreinigung bis zur Grundreinigung sind wir zuverlässig für Sie da.",
      "Wir arbeiten termintreu, versichert und mit einer festen Ansprechperson und stimmen Umfang sowie Intervalle genau auf Ihr Objekt in Landsberg am Lech ab.",
    ],
  },
];

export const locationBySlug = (slug) => locations.find((l) => l.slug === slug);
